import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { withStyles } from "@material-ui/core/styles";
import { Button, CircularProgress } from "@material-ui/core";
import green from "@material-ui/core/colors/green";

const styles = theme => ({
  wrapper: {
    position: "relative"
  },
  fullWidth:{
    width:"100%"
  },
  containedSuccess: {
    backgroundColor: `${green[500]} !important`,
    cursor: "default",
    "&:hover": {
      backgroundColor: `${green[500]} !important`
    },
    color: "white !important"
  },
  textSuccess: {
    color: `${green[500]} !important`,
    cursor: "default",
    "&:hover": {
      backgroundColor: `initial !important`
    }
  },
  variant: {},
  circularProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  textProgress: {
    color: green[500]
  }
});

const ButtonWillLoad = ({
  loading,
  success,
  successText,
  renderSuccess,
  loadingText,
  onClick,
  disabled,
  classes,
  children,
  className,
  buttonClasses,
  variant = "contained",
  color = "primary",
  fullWidth,
  ...props
}) => {
  const showLoadingElements = !success && loading;
  return (
    <div className={classNames(classes.wrapper, className, {[classes.fullWidth]:fullWidth})}>
      <Button
        variant={variant}
        color={color}
        className={classNames({
          [classes[`${variant}Success`]]: success
        })}
        disabled={disabled || loading || success}
        onClick={onClick}
        fullWidth={fullWidth}
        {...props}
        classes={buttonClasses}
      >
        {success && successText && successText}
        {success && renderSuccess && renderSuccess()}
        {showLoadingElements && loadingText && loadingText}
        {!loading && !success && children}
      </Button>
      {showLoadingElements && (
        <CircularProgress size={24} className={classes.circularProgress} />
      )}
    </div>
  );
};

ButtonWillLoad.propTypes = {
  loading: PropTypes.bool,
  success: PropTypes.bool,
  successText: PropTypes.string,
  laodingText: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ButtonWillLoad);



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonWillLoad.js